import React, { FC } from 'react';
import { ImageDataLike } from 'gatsby-plugin-image';
import { CardCarouselFragment, Kfh_ContentMarketReportType } from '../types/graphqlTypes';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { Section } from './Section';
import { Panel } from './Panel';
import { createMarkup } from '../utils';

// JSX

export const CardCarousel: FC<Omit<CardCarouselFragment, '__typename'>> = ({ title, items, button }) => {
  if (items.length < 1) {
    return null;
  }

  const generateId = (text?: string) => text?.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');

  return (
    <Section contained button={button} overflowHidden id={generateId(title)}>
      <CardCarouselWrapper heading={title}>
        {items.map(({ heading, text, image }, index) => (
          <Panel
            key={`cardcarousel-${index}`}
            backgroundColor="white"
            border
            heading={heading}
            iconImage={image?.localFile as unknown as ImageDataLike}
          >
            {createMarkup(text)}
          </Panel>
        ))}
      </CardCarouselWrapper>
    </Section>
  );
};
